// extracted by mini-css-extract-plugin
export var chip = "_53-0";
export var filterDropdown = "_53-5";
export var filterItem = "_53-6";
export var icon = "_53-1";
export var removeButton = "_53-3";
export var removeIcon = "_53-4";
export var separator = "_53-2";